// 画面で表示するメッセージを定義
const Messages = {
  // info
  I001: '登録します。\r\nよろしいですか？',
  I002: '登録しました。',
  I003: '削除します。\r\nよろしいですか？',
  I004: '削除しました。',
  I005: '',
  I006: '',
  I007: '',
  I008: '',
  I009: '',
  I010: '',
  I011: '',
  I012: '',
  I013: '',
  I014: '',
  I015: '',

  // warning
  W001: '必須入力です。',
  W002: '{0}文字で入力してください。',
  W003: '{0}文字以内で入力してください。',
  W004: '入力した値では、{0}に変換出来ません。',
  W005: '半角英数字で入力してください。',
  W006: '半角数字で入力してください。',
  W007: '全角カタカナで入力してください。',
  W008: '日付の前後関係が正しくありません。',
  W009: '入力エラーです。\r\n入力内容を確認してください。',
  W010: '実在する日付を入力してください。',
  W011: '画像サイズが{0}以内のものを選択してください。',
  W012: '拡張子がいずれかのものを選択してください。\r\n .png、.jpg',
  W013: '残入金額以下の値を入力してください。',
  W014: '他のユーザによって更新されたため登録できませんでした。\r\nデータを再読み込みしてから再度編集してください。',
  W015: '登録に失敗しました。\r\n入力したデータをメモしてから再読み込みして再入力してください。',
  W016: '以下の契約に関わる全てのデータが削除されます。\r\n本当によろしいですか？\r\n契約日：{0}\r\n契約者：{1}',
  W017: '以下の契約の状態をキャンセルにします。\r\n変更後は別の状態にすることはできません。\r\n本当によろしいですか？\r\n契約日：{0}\r\n契約者：{1}',
  W018: '当月を超える年月は指定できません。',
  W019: '表示メニューが一つも選択されておりません。',
  W020: 'メールアドレスまたはパスワードが違います。',
  W021: '{0}未満の値で入力してください。',
  W022: '{0}以下の値で入力してください。',
  W023: '{0}より大きい値で入力してください。',
  W024: '{0}以上の値で入力してください。',
  W025: '整数部分は{0}桁以内, 小数点以下は{1}桁以内で入力してください。',
  W026: '半角数字7文字で入力してください。',
  W027: '正しい電話番号を入力してください。',

  // error
  E001: '店舗を選択してください',
  E002: '事業年度を選択してください',
  E003: '',
  E004: '',
  E005: '',
  E006: '',
  E007: '',
  E008: '',
  E009: '',
  E010: '',
  E011: '',
  E012: '',
  E013: '',
  E014: '',
  E015: '',
}

export default Messages;